<template lang="pug">
  api-form(
    v-model="value"
    :fields="fields"
    :method="save"
    v-bind="$attrs"
  )
    template(v-slot:alert.default)
      p.
        Будет создан личный кабинет сотрудника вашей организации
        с указанными учетными данными, которые вам необходимо будет передать сотруднику
</template>

<script>
export default {
  name: 'ListenerForm',
  props: {
    successCallback: { type: Function, default: () => ({}) },
  },

  data: () => ({
    value: {},
    fields: [
      {
        text: 'Логин',
        value: 'name',
        rules: 'required',
        component: 'v-text-field',
        component_attrs: {
          filled: true,
          rounded: true,
        },
      },
      {
        text: 'Пароль',
        value: 'password',
        rules: 'required',
        component: 'v-text-field',
        component_attrs: {
          filled: true,
          rounded: true,
          type: 'password',
        },
      },
      {
        text: 'Фамилия',
        value: 'information_surname',
        rules: 'required',
        component: 'v-text-field',
        component_attrs: {
          filled: true,
          rounded: true,
        },
      },
      {
        text: 'Имя',
        value: 'information_first_name',
        rules: 'required',
        component: 'v-text-field',
        component_attrs: {
          filled: true,
          rounded: true,
        },
      },
      {
        text: 'Отчество',
        value: 'information_patronymic',
        component: 'v-text-field',
        component_attrs: {
          filled: true,
          rounded: true,
        },
      },
      {
        value: 'alert',
        component: 'v-alert',
        templates: ['default'],
        component_attrs: {
          text: true,
          type: 'info',
        },
      },
    ],
  }),
  methods: {
    save({ data, obs }) {
      return this.$rHandler(
        this.$api.users.relatedUsersCreate(data),
        (resp) => {
          this.successCallback(resp);
          return resp;
        },
        (resp) => new Error(resp),
        obs,
      );
    },
  },
};
</script>
